import React from 'react'

import { Colors } from 'common-constants/colors'

export const ComplaintSvg = ({
  size = 24,
  color = Colors.link,
}: {
  size?: number
  color?: string
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={color}>
        <g>
          <path
            d="M17 1c2.21 0 4 1.79 4 4v10c0 2.21-1.79 4-4 4h-2.297L8.51 22.716c-.117.07-.246.115-.38.134l-.135.009c-.512 0-.935-.386-.993-.884l-.007-.116V19l-.195-.005C4.684 18.891 3 17.142 3 15V5c0-2.21 1.79-4 4-4h10zm-5 12.979c-.828 0-1.5.671-1.5 1.5 0 .828.672 1.5 1.5 1.5s1.5-.672 1.5-1.5c0-.829-.672-1.5-1.5-1.5zm0-10c-.78 0-1.42.594-1.493 1.355l-.007.145v5l.007.144c.073.76.713 1.356 1.493 1.356.78 0 1.42-.595 1.493-1.356l.007-.144v-5l-.007-.145C13.42 4.574 12.78 3.98 12 3.98z"
            transform="translate(-1376 -262) translate(1376 262)"
          />
        </g>
      </g>
    </g>
  </svg>
)
